import React, { FC, useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { TeamContext, UserContext } from "../../../../context";
import { validateEmail } from "../helpers";
import { useCreateUser } from "../../../../hooks/index";

import JoinNewPlayer from "./JoinNewPlayer";
import JoinInsteadOfPlayer from "./JoinInsteadOfPlayer";
import JoiningInitially from "./JoiningInitially";
import CreateUserInputGeneric from "./CreateUserInputGeneric";
import { useTranslation } from "react-i18next";

const CreateUserMolecule: FC<{}> = () => {
	const { t } = useTranslation();
	const { roomUsers } = useContext(TeamContext);
	const { doesEmailExist, mailExists } = useContext(UserContext);
	const [loginData, setLoginData] = useCreateUser();
	
	const [emailInputMessage, setEmailInputMessage] = useState<string>("");
	const [fullNameInputMessage, setFullNameInputMessage] = useState<string>("");
	const [nicknameInputMessage, setNicknameInputMessage] = useState<string>("");

	const isGameCurrentlyRunning = useRef<boolean>(false);

	const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

	const doesUrlIncludeForce = windowLocationHref.includes("force");

	let history = useHistory();

	useEffect( () => {
		if(mailExists) {
			setEmailInputMessage(t("emailAlreadyInGameText"));
		}
	}, [mailExists])

	const isDisabled = !loginData.email ||
		!validateEmail(loginData.email) ||
		!loginData.fullName ||
		!loginData.nickname ||
		 loginData.nickname.length > 10 ||
		 loginData.fullName.length > 20 ||
		 mailExists;

	const emailHandler: Function = () => {
		if (!validateEmail(loginData.email))
			setEmailInputMessage(t("yourEmailAddressIsNotValiedText"));
		
		if (loginData.email.length > 50)
			setEmailInputMessage(t("thisEmailIsTooLongText"));

		doesEmailExist(loginData.email);
	};

	const fullNameHandler: Function = () => {
		if (!loginData.fullName)
			setFullNameInputMessage(t("pleaseEnterYourNameText"));
		
		if (loginData.fullName.length > 20)
			setFullNameInputMessage(t("theFullNameIsTooLongText"));

	};

	const nickNameHandler: Function = () => {
		if (!loginData.nickname)
			setNicknameInputMessage(t("pleaseEnterANicknameText"));
		
		if (loginData.nickname.length > 10)
			setNicknameInputMessage(t("thisNickanameIsTooLongText"));
	}

	const validateInputs = (fieldName: string) => {
		if (fieldName === "email")
			emailHandler();
		
		if (fieldName === "nickname")
			nickNameHandler();

		if (fieldName === "fullName")
			fullNameHandler();
	}

	const handleOnChange: Function = (fieldName: string, value: string) => {
		if (fieldName === "email")
			setEmailInputMessage("");

		if (fieldName === "fullName")
			setFullNameInputMessage("");

		if (fieldName === "nickname")
			setNicknameInputMessage("");

		setLoginData({
			...loginData,
			[fieldName]: value,
		});
	};

	useEffect( () => {
		roomUsers();
	}, []);

	useEffect( () => {
		isGameRunning();
	}, []);

	const isGameRunning = () => {
		axios({
			method: "get",
			url: process.env.REACT_APP_BACKEND_URL + `api/matches/is-game-running/${urlTokenExtracted}`,
		})
		.then((res: any) => {
			isGameCurrentlyRunning.current = res.data.isGameRunning
			if(isGameCurrentlyRunning.current)	history.push("/joinMidGame/"+urlTokenExtracted)
		})
		.catch((err: any) => console.error(err));
	}

	return (
		<React.Fragment>

			<CreateUserInputGeneric 
				type="email"
				message={emailInputMessage} 
				value={loginData.email} 
				handleOnChange={(type: string, value: any) => handleOnChange(type, value)}
				validateInputs={(type: any) => validateInputs(type)}
			/>

			<CreateUserInputGeneric 
				type="nickname"
				message={nicknameInputMessage} 
				value={loginData.nickname} 
				handleOnChange={(type: string, value: any) => handleOnChange(type, value)}
				validateInputs={(type: any) => validateInputs(type)}
			/>

			<CreateUserInputGeneric 
				type="fullName"
				message={fullNameInputMessage} 
				value={loginData.fullName} 
				handleOnChange={(type: string, value: any) => handleOnChange(type, value)}
				validateInputs={(type: any) => validateInputs(type)}
			/>

			<div className="input_wrapper__main_button">
				{/* <button onClick={isGameRunning}> {t("isGameRunningText")} </button> */}
				{isGameCurrentlyRunning.current && <JoinNewPlayer urlTokenExtracted={urlTokenExtracted} loginData={loginData} isDisabled={isDisabled} />}
				{isGameCurrentlyRunning.current && doesUrlIncludeForce && <JoinInsteadOfPlayer urlTokenExtracted={urlTokenExtracted} isDisabled={isDisabled} />}
				{!isGameCurrentlyRunning.current && <JoiningInitially loginData={loginData} isDisabled={isDisabled} />}
			</div>

		</React.Fragment>
	);

};

export default CreateUserMolecule;